export default "__VITE_ASSET__CA_FqIwJ__"